// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const savesHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.saves_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.saves_history_name',
        avg: 'chart.pinterest.saves_history_avg'
    },
    id: 'saves_history',
    color: {
        value: 'purple',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.pinterest.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.pinterest.tooltip_saves_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
